import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="subscription"
export default class extends Controller {
	connect() {
    console.log('hello')
		this.interval = setInterval(() => {
			Turbo.visit(window.location.href);
		}, 2000);
	}

	disconnect() {
		clearInterval(this.interval);
	}
}
